import { SectionHeading } from "./styled/fragments";
import SystemHealth from "./SystemHealth";
import SystemInfo from "./SystemInfo";

const SystemPanel: React.SFC = () => (
	<div>
		<SectionHeading title="Runtime Info" />

		<SystemInfo padding={false} />

		<SectionHeading title="Health Report" />

		<SystemHealth padding={false} expandedDefault={true} />

		<SectionHeading title="Config & Editing" />
	</div>
);

export default SystemPanel;



// WEBPACK FOOTER //
// ./src/core/components/editor/SystemPanel.tsx